// @flow
import { finect as theme } from '@finect/tabular-themes/finect';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { SEGMENTS } from '@finect/content-urls';
// import { PrivateRoute } from '@finect/front-core/Routes';
import { contents, products } from './../configs';
import { OTHER_TAGS } from './../scenes/Storefronts/Personal/data';

// SSR paths
import {
  FundsList,
  FundSheet,
  FundSheetById,
  ETFsHome,
  PlansHome,
  FundsHome,
  FundsCategories,
  FundsCategory,
  FundsManagementCompanies,
  FundsManagementCompany,
  FundsComparison,
  ProductSheet,
  CryptoSheet,
  CryptoList,
  ProductQuestions,
  ProductReviews,
  ProductReview,
  WriteReview,
  ArticleScroll,
  Groups,
  MultimediaCommons,
  Latest,
  Storefront,
  StorefrontProductsList,
  DigitalHome,
  DigitalAcademy,
  AlternativesHome,
  AlternativesAcademy,
  PersonalHome,
  PersonalTag,
  // Favoritos - OLD
  Favorites,
  Panel,
  Feed,
  // Favoritos - Finect Plus
  MyAnalysis,
  MyPortfolio,
  SharedPortfolio,
  SponsoredPortfolios,
  PlusChatbot,
  // Bancos
  Bank,
  BankArticle,
  BankProducts,
  BankArticleList,
  Tag,
  TagsHome,
  Home,
  OnBoarding,
  Euribor,
  ProductSubscription,
  SubscriptionConditions,
  PlusSubscriptionConditions,
  UserProfileLayout,
  Group,
  VersionNotes,
  SegmentRoot,
  SegmentArticle,
  SegmentNoticias,
  SegmentVertical,
  SegmentHub
} from './';

const base = '';
const iicRoutes = [
  {
    path: theme.routes.FundsList,
    exact: true,
    components: [FundsList]
  },
  {
    path: `${base}/${theme.partner.iic.slugs.fund}`,
    exact: true,
    components: [FundsHome]
  },
  {
    path: `${base}/${theme.partner.iic.slugs.etf}`,
    exact: true,
    components: [ETFsHome]
  },
  {
    path: `${base}/${theme.partner.iic.slugs.plan}`,
    exact: true,
    components: [PlansHome]
  },
  {
    path: theme.partner.routes.FundsComparison,
    exact: true,
    components: [FundsComparison]
  },
  {
    path: theme.partner.routes.FundsCategories,
    exact: true,
    components: [FundsCategories]
  },
  {
    path: theme.partner.routes.FundsCategoriesTab,
    exact: true,
    components: [FundsCategories]
  },
  {
    path: theme.partner.routes.FundsCategory,
    components: [FundsCategory],
    exact: true
  },
  {
    path: theme.partner.routes.FundsCategory.replace('-:alias', ''),
    components: [FundsCategory],
    exact: true
  },
  {
    path: theme.partner.routes.FundsManagementCompanies,
    components: [FundsManagementCompanies],
    exact: true
  },
  {
    path: theme.partner.routes.FundsManagementCompany,
    components: [FundsManagementCompany],
    exact: true
  },
  {
    path: theme.partner.routes.FundsManagementCompany.replace('-:alias', ''),
    components: [FundsManagementCompany],
    exact: true
  },
  {
    path: theme.partner.routes.FundSheet,
    exact: true,
    components: [FundSheet]
  },
  {
    path: theme.partner.routes.FundSheetById,
    exact: true,
    components: [FundSheetById]
  }
];

type Route = {
  path: string,
  exact: boolean,
  components: Array<React$ComponentType<any>>,
  params?: { [key: string]: any },
  omninavShadow?: boolean
};

export const routes: Array<Route> = [
  ...iicRoutes,

  // Portada / contenidos
  {
    path: '/',
    exact: true,
    components: [Home]
  },
  {
    path: '/euribor',
    exact: true,
    components: [Euribor]
  },
  ...isPreRelease
    ? [
      { path: '/activos-digitales/listado', exact: true, components: [CryptoList] },
      { path: '/activos-digitales/:productSlug', exact: true, components: [CryptoSheet] },
      { path: '/criptos/:productSlug', exact: true, components: [CryptoSheet] },
      { path: '/criptos', exact: true, components: [CryptoList] }
    ]
    : [],
  {
    path: products.routes.sheet,
    exact: true,
    components: [ProductSheet]
  },
  {
    path: theme.partner.routes.FundQuestions,
    exact: true,
    components: [ProductQuestions]
  },
  {
    path: theme.partner.routes.ProductQuestions,
    exact: true,
    components: [ProductQuestions]
  },

  // Reviews
  {
    path: theme.partner.routes.ProductReviews,
    exact: true,
    components: [ProductReviews]
  },
  {
    path: theme.partner.routes.FundReviews,
    exact: true,
    components: [ProductReviews]
  },
  {
    path: contents.routes.contentReview,
    exact: true,
    components: [ProductReview]
  },
  {
    path: contents.routes.iicReview,
    exact: true,
    components: [ProductReview]
  },
  {
    path: theme.partner.routes.ProductWriteReview,
    exact: true,
    components: [WriteReview]
  },
  {
    path: theme.partner.routes.FundWriteReview,
    exact: true,
    components: [WriteReview]
  },
  // En esta línea estaban las rutas de IICs.
  {
    path: '/articulos/:article',
    exact: true,
    components: [ArticleScroll]
  },
  {
    path: '/:subtype(grupos|usuario)/:profile/articulos/:article',
    exact: true,
    components: [ArticleScroll]
  },
  // Segmentos de contenido (hipotecas, seguros, ...) — generados desde @finect/content-urls.
  // Este registro alimenta el SSR (loadRouteDependencies). Debe reflejar AppRouter.js.
  ...Object.entries(SEGMENTS).flatMap(([key, config]) => {
    if (config.verticals) {
      // Anidado (seguros) — más específico primero.
      return [
        {
          path: `${config.basePath}/:vertical/:cluster`,
          exact: true,
          components: [SegmentArticle],
          params: { segment: key }
        },
        {
          path: `${config.basePath}/:vertical`,
          exact: true,
          components: [SegmentVertical],
          params: { segment: key }
        },
        {
          path: config.basePath,
          exact: true,
          components: [SegmentHub],
          params: { segment: key }
        }
      ];
    }

    // Plano (hipotecas).
    return [
      {
        path: config.basePath,
        exact: true,
        components: [SegmentRoot],
        params: { segment: key }
      },
      {
        path: `${config.basePath}/noticias`,
        exact: true,
        components: [SegmentNoticias],
        params: { segment: key }
      },
      {
        path: `${config.basePath}/:slug`,
        exact: true,
        components: [SegmentArticle],
        params: { segment: key }
      }
    ];
  }),
  {
    path: '/grupos',
    exact: true,
    components: [Groups]
  },
  {
    path: '/videos',
    exact: true,
    components: [MultimediaCommons],
    params: { type: 'video' }
  },
  {
    path: '/podcasts',
    exact: true,
    components: [MultimediaCommons],
    params: { type: 'podcast' }
  },
  // El listado completo. La portada reparte entre destacado, imprescindibles y ultimos, y manda aqui
  // a quien quiera verlo todo.
  {
    path: '/videos/todos',
    exact: true,
    components: [MultimediaCommons],
    params: { type: 'video', archive: true }
  },
  {
    path: '/podcasts/todos',
    exact: true,
    components: [MultimediaCommons],
    params: { type: 'podcast', archive: true }
  },
  {
    path: '/articulos-financieros/noticias',
    exact: true,
    components: [Latest],
    params: { type: 'noticias' }
  },
  {
    path: '/articulos-financieros/en-un-minuto',
    exact: true,
    components: [Latest],
    params: { type: 'en-un-minuto' }
  },
  {
    path: '/articulos-financieros/a-fondo',
    exact: true,
    components: [Latest],
    params: { type: 'a-fondo' }
  },
  {
    path: '/invertir/:tag',
    exact: true,
    components: [Storefront],
    omninavShadow: true
  },
  {
    path: '/invertir/:tag/listado',
    exact: true,
    components: [StorefrontProductsList],
    omninavShadow: true
  },
  {
    path: theme.partner.routes.DigitalHome,
    exact: true,
    components: [DigitalHome],
    omninavShadow: false
  },
  {
    path: `${theme.partner.routes.DigitalHome}/formacion`,
    exact: true,
    components: [DigitalAcademy],
    omninavShadow: false
  },
  {
    path: `${theme.partner.routes.AlternativesHome}`,
    exact: true,
    components: [AlternativesHome],
    omninavShadow: false
  },
  {
    path: `${theme.partner.routes.AlternativesHome}/formacion`,
    exact: true,
    components: [AlternativesAcademy],
    omninavShadow: false
  },
  {
    path: `${theme.partner.routes.PersonalHome}`,
    exact: true,
    components: [PersonalHome],
    omninavShadow: false
  },
  ...OTHER_TAGS.map(tag => ({
    path: `${theme.partner.routes.PersonalHome}/${tag.slug}`,
    exact: true,
    components: [PersonalTag],
    params: { contentTag: tag }
  })),
  /* Favoritos - OLD */
  {
    path: '/(mis|tus)-productos',
    exact: true,
    components: [Favorites]
  },
  {
    path: '/(mis|tus)-finanzas',
    exact: true,
    components: [Panel]
  },
  {
    path: '/(mis|tus)-temas',
    exact: true,
    components: [Feed]
  },
  /* Finect Plus */
  {
    path: '/plus/(mi|tu)-analisis',
    exact: true,
    components: [MyAnalysis]
  },
  {
    path: '/plus/micartera',
    exact: true,
    components: [MyPortfolio]
  },
  {
    path: '/carteras/:token',
    exact: true,
    components: [SharedPortfolio]
  },
  {
    path: '/plus/carteras',
    exact: true,
    components: [SponsoredPortfolios]
  },
  {
    path: '/plus/asistente',
    exact: true,
    components: [PlusChatbot]
  },
  {
    path: '/plus/novedades',
    exact: true,
    components: [VersionNotes]
  },
  // Bancos
  {
    path: '/bancos/:organization',
    exact: true,
    components: [Bank],
    omninavShadow: true
  },
  {
    path: '/bancos/:organization/articulos/:article',
    exact: true,
    components: [BankArticle],
    omninavShadow: true
  },
  {
    path: '/bancos/:organization/productos',
    exact: true,
    components: [BankProducts],
    omninavShadow: true
  },
  {
    path: '/bancos/:organization/productos/:typeSlug',
    exact: true,
    components: [BankProducts],
    omninavShadow: true
  },
  {
    path: '/bancos/:organization/analisis',
    exact: true,
    components: [BankArticleList],
    omninavShadow: true
  },
  {
    path: '/temas/:tag',
    exact: true,
    components: [Tag]
  },
  {
    path: '/temas',
    exact: true,
    components: [TagsHome]
  },
  {
    path: '/onboarding',
    exact: true,
    components: [OnBoarding]
  },
  {
    path: '/usuario/:alias',
    exact: true,
    components: [UserProfileLayout]
  },
  {
    path: '/usuario/:alias/:tab(respuestas|articulos|reviews)',
    exact: true,
    components: [UserProfileLayout]
  },
  {
    path: '/grupos/:profile',
    exact: true,
    components: [Group]
  },
  {
    path: '/grupos/:profile/:tab',
    exact: true,
    components: [Group]
  },
  {
    path: `/:productTypeSlug(servicios)/:productSlug(finect-subscription|finect-plus)/comprar`,
    exact: true,
    components: [ProductSubscription]
  },
  {
    path: `/:productTypeSlug(servicios)/:productSlug(finect-subscription)/condiciones`,
    exact: true,
    components: [SubscriptionConditions]
  },
  {
    path: `/:productTypeSlug(servicios)/:productSlug(finect-plus)/condiciones`,
    exact: true,
    components: [PlusSubscriptionConditions]
  }
];
